import styled from "styled-components";
import {
  color_grey_ultra_dark,
  color_red_active,
  color_red_default,
  color_white,
} from "../../constants/colors";

export const AdminShell = styled.main`
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  padding: 0 0 48px;
  overflow-x: clip;
  box-sizing: border-box;
  color: ${color_grey_ultra_dark};
  font-family: Onest, sans-serif;

  @media (max-width: 720px) {
    padding: 0 0 32px;
  }
`;

export const AdminHeader = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`;

export const AdminTitle = styled.h1`
  margin: 0 0 6px;
  font: 700 32px/1.15 Onest, sans-serif;
  letter-spacing: -0.035em;
`;

export const AdminSubtitle = styled.p`
  margin: 0;
  color: #8a8a8a;
  font: 400 13px/1.4 Onest, sans-serif;
`;

export const PeriodSwitch = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  border-radius: 14px;
  background: #ecebea;
  box-sizing: border-box;
`;

export const PeriodButton = styled.button`
  min-width: 84px;
  height: 38px;
  padding: 0 14px;
  border: 0;
  border-radius: 11px;
  background: ${(props) => (props.$active ? color_white : "transparent")};
  color: ${(props) => (props.$active ? color_grey_ultra_dark : "#777")};
  box-shadow: ${(props) =>
    props.$active ? "0 2px 8px rgba(54, 54, 54, 0.08)" : "none"};
  font: 500 13px/1 Onest, sans-serif;
  white-space: nowrap;
  cursor: pointer;
`;

export const MetricGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 230px), 1fr));
  gap: 12px;
  margin-bottom: 14px;
`;

export const MetricCard = styled.article`
  min-height: 142px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border: 1px solid #eeeeec;
  border-radius: 20px;
  background: ${color_white};
  box-sizing: border-box;
`;

export const MetricLabel = styled.span`
  color: #777;
  font: 500 13px/1.35 Onest, sans-serif;
`;

export const MetricValue = styled.strong`
  display: block;
  margin-top: 12px;
  overflow-wrap: anywhere;
  font: 700 clamp(22px, 2.1vw, 30px)/1.1 Onest, sans-serif;
  letter-spacing: -0.04em;
`;

export const MetricHint = styled.span`
  color: ${(props) => props.$warning ? "#8555c8" : "#8a8a8a"};
  font: 400 12px/1.4 Onest, sans-serif;
`;

export const InsightGrid = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 14px;

  @media (min-width: 1280px) {
    grid-template-columns: minmax(0, 1.4fr) minmax(240px, 0.6fr);
  }
`;

export const Panel = styled.article`
  min-width: 0;
  padding: 22px;
  border: 1px solid #eeeeec;
  border-radius: 20px;
  background: ${color_white};
  box-sizing: border-box;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font: 600 18px/1.3 Onest, sans-serif;
`;

export const PanelHint = styled.p`
  margin: 5px 0 0;
  color: #8a8a8a;
  font: 400 12px/1.4 Onest, sans-serif;
`;

export const FunnelList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FunnelRow = styled.div`
  display: grid;
  grid-template-columns: minmax(92px, 28%) minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font: 400 13px/1.3 Onest, sans-serif;
`;

export const FunnelTrack = styled.div`
  height: 9px;
  overflow: hidden;
  border-radius: 99px;
  background: #f0efed;
`;

export const FunnelFill = styled.div`
  width: ${(props) => `${Math.max(2, props.$percent)}%`};
  height: 100%;
  border-radius: inherit;
  background: ${(props) => props.$color || color_red_default};
`;

export const FunnelValue = styled.strong`
  text-align: right;
  white-space: nowrap;
  font: 600 13px/1 Onest, sans-serif;
`;

export const TariffSplit = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const TariffCard = styled.div`
  padding: 16px;
  border-radius: 16px;
  background: ${(props) => props.$background || "#f7f6f4"};
`;

export const TariffValue = styled.strong`
  display: block;
  margin-bottom: 6px;
  font: 700 26px/1 Onest, sans-serif;
`;

export const TariffLabel = styled.span`
  color: #777;
  font: 400 12px/1.35 Onest, sans-serif;
`;

export const QueuePanel = styled.section`
  min-width: 0;
  padding: 22px;
  overflow: hidden;
  border: 1px solid #eeeeec;
  border-radius: 20px;
  background: ${color_white};
  box-sizing: border-box;
`;

export const QueueTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
`;

export const QueueTab = styled.button`
  height: 40px;
  padding: 0 14px;
  border: 1px solid
    ${(props) => (props.$active ? color_red_default : "#e6e5e3")};
  border-radius: 999px;
  background: ${(props) => (props.$active ? color_red_default : color_white)};
  color: ${(props) => (props.$active ? color_white : "#686868")};
  font: 500 13px/1 Onest, sans-serif;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    border-color: ${color_red_default};
  }
`;

export const QueueTools = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 720px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  max-width: 380px;
  height: 44px;
  padding: 0 15px;
  border: 1px solid #e6e5e3;
  border-radius: 13px;
  outline: 0;
  box-sizing: border-box;
  color: ${color_grey_ultra_dark};
  font: 400 14px/1 Onest, sans-serif;

  &:focus {
    border-color: ${color_red_default};
    box-shadow: 0 0 0 3px rgba(240, 79, 79, 0.12);
  }
`;

export const QueueCount = styled.span`
  color: #777;
  font: 400 13px/1.4 Onest, sans-serif;
`;

export const EmptyState = styled.div`
  padding: 48px 20px;
  color: #8a8a8a;
  text-align: center;
  font: 400 14px/1.4 Onest, sans-serif;
`;

export const AccessDenied = styled.div`
  max-width: 520px;
  margin: 80px auto;
  padding: 32px;
  border-radius: 20px;
  background: ${color_white};
  text-align: center;

  h1 {
    margin: 0 0 10px;
    font: 700 28px/1.2 Onest, sans-serif;
  }

  p {
    margin: 0;
    color: #777;
    font: 400 14px/1.45 Onest, sans-serif;
  }
`;

export const LoadingState = styled.div`
  padding: 72px 20px;
  color: ${color_red_active};
  text-align: center;
  font: 500 14px/1.4 Onest, sans-serif;
`;

export const CashPanel = styled.section`
  min-width: 0;
  margin-bottom: 14px;
  padding: 22px;
  overflow: hidden;
  border: 1px solid #eeeeec;
  border-radius: 20px;
  background: ${color_white};
  box-sizing: border-box;
`;

export const MonthPicker = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const MonthSelect = styled.select`
  height: 40px;
  min-width: 120px;
  padding: 0 12px;
  border: 1px solid #e6e5e3;
  border-radius: 12px;
  background: #f7f6f4;
  color: ${color_grey_ultra_dark};
  font: 500 13px/1 Onest, sans-serif;
  cursor: pointer;

  &:focus {
    border-color: ${color_red_default};
    outline: 0;
    box-shadow: 0 0 0 3px rgba(240, 79, 79, 0.12);
  }
`;

export const CashSplit = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 160px), 1fr));
  gap: 10px;
`;

export const CashTableWrap = styled.div`
  max-height: 320px;
  margin-top: 16px;
  overflow: auto;
  border: 1px solid #eeeeec;
  border-radius: 14px;
`;

export const CashTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font: 400 12px/1.35 Onest, sans-serif;

  th,
  td {
    padding: 8px 10px;
    text-align: left;
    white-space: nowrap;
    border-bottom: 1px solid #f0efed;
  }

  th {
    position: sticky;
    top: 0;
    background: #f7f6f4;
    color: #777;
    font-weight: 600;
  }
`;

export const CashSkip = styled.span`
  color: ${(props) => (props.$ok ? "#17ad65" : "#c45b5b")};
`;
